var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('div',[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v(_vm._s(_vm.iconName))]),_c('div',{staticClass:"caption"},[_vm._v(_vm._s(_vm.caption))])],1),_c('div',{staticClass:"ml-2 display-1 text--secondary",domProps:{"textContent":_vm._s(_vm.value)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }